var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "qrcode-popup",
      style: {
        left: _vm.left ? _vm.left + "px" : "",
        top: _vm.top ? _vm.top + "px" : ""
      }
    },
    [
      _c("img", {
        staticClass: "qrcode-thumb",
        attrs: {
          src: require("@/assets/img/resources/" +
            (_vm.product_id | _vm.utils.product_id_boolean
              ? "code/" + _vm.product_id + "_code.jpg"
              : "WechatIMG146.jpeg"))
        }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "f14 gray-1 text-center" }, [
        _vm._v("请使用微信扫一扫下单")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1809fae3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1809fae3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/weChatCode.vue
// module id = null
// module chunks = 